module.exports = __webpack_public_path__ + "static/media/CENTRO_AMERICA_FM.ddc43396.png";